import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { ChangeGroupOwnerPayload } from '@modules/groups-of-admins/submodules/edit/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { GROUPS_OF_ADMINS_LIST_QUERY_KEY, GROUPS_OF_ADMINS_PERMISSIONS } from '@modules/groups-of-admins/constants';
import { GROUPS_OF_ADMINS_CREATE_QUERY_KEY } from '@modules/groups-of-admins/submodules/create/constants';
import {
  AVAILABLE_ADMINS_LIST_QUERY_KEY,
  GROUPS_OF_ADMINS_EDIT_OWNER_MUTATION_API_URL,
  GROUPS_OF_ADMINS_EDIT_OWNER_MUTATION_KEY,
  OWNERS_LIST_QUERY_KEY,
} from '@modules/groups-of-admins/submodules/edit/constants';
import { useToastStore } from '@modules/toast/store';

export default function useGroupsOfAdminsChangeGroupOwnerMutation(): IContextMutationResult<
  void,
  Error,
  ChangeGroupOwnerPayload
> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, ChangeGroupOwnerPayload>({
    mutationKey: [GROUPS_OF_ADMINS_EDIT_OWNER_MUTATION_KEY],
    mutationFn: (payload) => fetchPut<void>(
      GROUPS_OF_ADMINS_EDIT_OWNER_MUTATION_API_URL,
      { admin_group: { admin_id: payload.admin_id } },
      {
        permission: GROUPS_OF_ADMINS_PERMISSIONS.EDIT,
        urlParams: {
          id: payload.id,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [OWNERS_LIST_QUERY_KEY] }),
        queryClient.invalidateQueries({ queryKey: [GROUPS_OF_ADMINS_CREATE_QUERY_KEY] }),
        queryClient.invalidateQueries({ queryKey: [AVAILABLE_ADMINS_LIST_QUERY_KEY] }),
        queryClient.invalidateQueries({ queryKey: [GROUPS_OF_ADMINS_LIST_QUERY_KEY] }),
      ]);
      displayPresetToast('success');
    },
  });
}
